import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=a308ab8a"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports